import { Box, Typography } from '@mui/material';
import React, { FC } from 'react';
import { useStyles } from './BracketTournamentCodeModalHeader.styles';

interface BracketTournamentCodeModalHeaderProps {
  icon?: string;
  title: string;
}

export const BracketTournamentCodeModalHeader: FC<BracketTournamentCodeModalHeaderProps> = ({
  icon,
  title,
}) => {
  const { classes } = useStyles();

  return (
    <Box className={classes.root}>
      <img className={classes.icon} src={icon} alt="game-icon" />
      <Typography variant="h6">{title}</Typography>
    </Box>
  );
};
